<template>
  <form-filtered-multiselect
    :value="storedProviders"
    :options="providerOptions"
    :placeholder="placeholder"
    :limit-height="limitHeight"
    :hide-selected="hideSelected"
    :disabled="disabled"
    track-by="value"
    label="label"
    @input="onProvidersSelected" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    limitHeight: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select Providers'
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      storedProviders: []
    }
  },
  computed: {
    ...mapGetters('provider', ['providerOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedProviders = newVal
    }
  },
  created () {
    this.storedProviders = this.selectedKeys
  },
  methods: {
    onProvidersSelected (providers) {
      this.$emit('valuesSelected', providers)
    }
  }
}
</script>

<style>

</style>
